import { filterMenuByModels } from '@/utils/menuUtils';

const HIDDEN_SIDEBAR_MENU_MODELS = ['notificacionres'];

const cloneConfiguration = function (gridConfiguration) {
	const newGridConfiguration = Object.assign({}, gridConfiguration);
	newGridConfiguration.configuration = Object.assign({}, gridConfiguration.configuration);
	const columns = [];
	const order = [];
	newGridConfiguration.configuration.order && newGridConfiguration.configuration.order.forEach(sortingRule => order.push(sortingRule));
	newGridConfiguration.configuration.order = order;
	newGridConfiguration.configuration.columns && newGridConfiguration.configuration.columns.forEach(column => columns.push(column));
	newGridConfiguration.configuration.columns = columns;
	return newGridConfiguration;
};

export default {
	loadDefaultGridConfiguration(store, params) {
		const { modelName, checkColumns = false } = params;
		var currentConfig = store.getters.getCurrentGridConfiguration(modelName);
		if (checkColumns && currentConfig && !currentConfig.configuration.columns) currentConfig = null;
		if (!currentConfig) {
			const defaultConfig = store.getters.getDefaultGridConfiguration(modelName);
			if (defaultConfig) {
				console.log(store);
				var gridConfiguration = cloneConfiguration(defaultConfig);
				store.commit('puiModelsSetCurrentGridConfiguration', { model: modelName, configuration: gridConfiguration });
			}
		}
	},

	async puiMenuGetInfoMenu({ state, commit, getters }) {
		if (!state.httpRequestHeaders.Authorization) {
			return;
		}

		try {
			const { data } = await this.$app.$puiRequests.getRequest('/puimenu/getMenu');
			const breadcrumbItems = JSON.parse(JSON.stringify(data));
			const sidebarItems = filterMenuByModels(data, HIDDEN_SIDEBAR_MENU_MODELS);

			commit('setMenuBreadcrumbItems', breadcrumbItems);
			commit('setMenuParentItems', null);
			commit('setMenuCurrentItems', sidebarItems);
			commit('setMenuItems', sidebarItems);
		} catch (error) {
			const message = getters.getTranslate('puimenu.errorLoadingMenu');
			this.$app.$puiNotify.error(message);
		}
	}
};
